import moment from 'moment';
import React from 'react';
import { isQAActive } from '../../data/filters/questions/isQAActive';
import Validate from './Validate';

export default ({eventId, children}) => (
    <Validate
        validate={state => {
            let now = moment(),
                event = _.get(state.events[eventId], 'event');
            if (!event) {
                throw new Error('Event not found');
            }
            if (!isQAActive(event)) {
                throw new Error('Unable to post questions: QA is closed.');
            }
        }}>
        {children}
    </Validate>
);
